import { useHandler } from "@chatbotgang/etude/react/useHandler";
import Stack from "@mui/material/Stack";
import { theme } from "@polifonia/theme";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/Button";
import { Modal } from "@/components/Modal";
import { Typography } from "@/components/Typography";

interface DisconnectLineAdsModalProps {
  open: boolean;
  isLoading: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const DisconnectLineAdsModal: React.FC<DisconnectLineAdsModalProps> =
  function DisconnectLineAdsModal({ open, isLoading, onClose, onConfirm }) {
    const { t } = useTranslation();
    const handleClose = useHandler(() => {
      if (isLoading) return;
      onClose();
    });

    return (
      <Modal
        open={open}
        handleClose={handleClose}
        title={t(
          "applications.lineAds.disconnectModal.title",
          "Disconnect LINE Ads?",
        )}
        footer={
          <Stack direction="row" justifyContent="flex-end" gap="12px">
            <Button
              variant="secondary"
              onClick={handleClose}
              disabled={isLoading}
            >
              {t("common.cancel")}
            </Button>
            <Button
              variant="danger"
              onClick={onConfirm}
              loading={isLoading}
              disabled={isLoading}
            >
              {t("applications.lineAds.disconnectModal.confirm", "Disconnect")}
            </Button>
          </Stack>
        }
      >
        <Typography variant="body" color={theme.colors.staticFgBody}>
          {t(
            "applications.lineAds.disconnectModal.message",
            "The group and all of its ad accounts will be removed. To use LINE Ads again, connect with the group ID and API keys.",
          )}
        </Typography>
      </Modal>
    );
  };
